export var ECompareType = /*#__PURE__*/function (ECompareType) {
  ECompareType["Eq"] = "eq";
  ECompareType["InList"] = "inList";
  return ECompareType;
}({});